<template>
  <EuiCard class="my-2">
    <EuiGrid>
      <EuiGridRow class="mt-2">
        <EuiHeading :level="3" bold class="my-auto">UserStatus: </EuiHeading>
        <span
          class="mx-1 px-4 py-1 userStatus"
          :class="'userStatus_' + detailBoxe.userStatus"
        >
          {{ explicitUserStatus }}
        </span>
      </EuiGridRow>
      <EuiGridRow class="mt-2">
        <EuiHeading :level="3" bold>Identifiant</EuiHeading>
      </EuiGridRow>
      <EuiGridRow>eFoliaId: {{ detailBoxe.efoliaId }}</EuiGridRow>
      <div v-if="detailBoxe.efoliaIds && detailBoxe.efoliaIds.length > 0">
        <EuiGridRow class="ml-16" v-for="id in cleanEfoliaIds" :key="id.index">
          <span v-if="id !== detailBoxe.efoliaId">{{ id }}</span>
        </EuiGridRow>
      </div>
      <EuiGridRow>userId: {{ detailBoxe.userId }}</EuiGridRow>
      <EuiGridRow>Login: {{ detailBoxe.login }}</EuiGridRow>
      <EuiGridRow>Email: {{ detailBoxe.email }}</EuiGridRow>
      <EuiGridRow justify="between">
        <span>Question secrète: {{ explicitQuestion }}</span>
        <span>Réponse: {{ detailBoxe.answer }}</span>
      </EuiGridRow>
      <EuiGridRow class="mt-2">
        <EuiHeading :level="3">Identité</EuiHeading>
      </EuiGridRow>
      <EuiGridRow justify="between">
        <span>Prénom: {{ detailBoxe.firstname }}</span>
        <span>Nom: {{ detailBoxe.lastname }}</span>
      </EuiGridRow>
      <EuiGridRow>Genre: {{ detailBoxe.gender }}</EuiGridRow>
      <EuiGridRow justify="between">
        <span>Date de naissance: {{ detailBoxe.birthDate }}</span>
        <span
          >Code d'activation:
          <span v-if="detailBoxe.activationCode">{{
            detailBoxe.activationCode
          }}</span>
          <span v-else>null</span>
        </span>
      </EuiGridRow>
      <EuiGridRow class="mt-2">
        <EuiHeading :level="3"
          >Dernières tentatives d'authentification
        </EuiHeading>
      </EuiGridRow>
      <EuiGridRow>
        <div
          v-if="
            detailBoxe.badAuthenticationLogs &&
            detailBoxe.badAuthenticationLogs.length === 0
          "
        >
          Aucun log
        </div>
        <div v-else>
          <div
            class="my-3"
            v-for="log in detailBoxe.badAuthenticationLogs"
            :key="log.index"
          >
            <div class="inline-block ml-4">
              Id: {{ log.id }} le {{ log.date }}
            </div>
          </div>
        </div>
      </EuiGridRow>
      <EuiGridRow class="mt-2">
        <EuiHeading :level="3">Historique des IP de login </EuiHeading>
      </EuiGridRow>
      <EuiGridRow>
        <div v-if="!detailBoxe.loginTrials">Aucun historique</div>
        <div
          v-else-if="
            JSON.stringify(detailBoxe.loginTrials) === JSON.stringify({})
          "
        >
          Aucun historique
        </div>
        <div v-else>
          <div
            class="my-3"
            v-for="(timestamp, ip) in detailBoxe.loginTrials"
            :key="timestamp.id"
          >
            <div class="inline-block ml-4">ip {{ ip }} le {{ timestamp }}</div>
          </div>
        </div>
      </EuiGridRow>
      <EuiGridRow class="mt-2">
        <EuiHeading :level="3">Status de dématérialisation </EuiHeading>
      </EuiGridRow>
      <EuiGridRow>
        <div v-if="detailBoxe.payeServices.length === 0">Aucun status</div>
        <div v-else class="w-full">
          <div
            class="my-4"
            v-for="service in detailBoxe.payeServices"
            :key="service.index"
          >
            <div class="inline-block my-1 ml-2">
              Name: {{ service.providerName }}
            </div>
            <div class="inline-block my-1 ml-2">
              Siret: {{ service.providerSiret }}
            </div>
            <div class="inline-block my-1 ml-2">
              Accord nécessaire: {{ service.needsUserAgreement }}
            </div>
            <div class="inline-block my-1 ml-2 mr-1">
              <span> Status: </span>
              <span
                v-if="service.agreementStatus"
                class="dematStatus"
                :class="service.agreementStatus"
              >
                {{ service.agreementStatus }}
              </span>
              <span v-else>Aucun</span>
            </div>
          </div>
        </div>
      </EuiGridRow>
      <EuiGridRow class="mt-2">
        <EuiHeading :level="3">Adresse</EuiHeading>
      </EuiGridRow>
      <EuiGridRow> Adresse: {{ detailBoxe.address }} </EuiGridRow>
      <EuiGridRow justify="between">
        <span>Code postal: {{ detailBoxe.zipCode }}</span>
        <span>Ville: {{ detailBoxe.town }}</span>
      </EuiGridRow>
      <EuiGridRow class="mt-2">
        <EuiHeading :level="3">Autres informations</EuiHeading>
      </EuiGridRow>
      <EuiGridRow justify="between">
        <span
          >Téléphone:
          <span v-if="detailBoxe.phone !== null">
            {{ detailBoxe.phone }}
          </span>
          <span v-else> Aucun </span>
        </span>
        <span>Numéro Insee: {{ detailBoxe.inseeNum }}</span>
        <span>Adulte: {{ detailBoxe.isAnAdult }}</span>
      </EuiGridRow>
      <EuiGridRow justify="between">
        <span
          >Accord sur les dernières CGU: {{ detailBoxe.agreedToLastCGU }}</span
        >
        <span
          >Lié par France Connect:
          {{ detailBoxe.isLinkedToFranceConnect }}</span
        >
      </EuiGridRow>
    </EuiGrid>
    <!-- {{ detailBoxe}} -->
  </EuiCard>
</template>

<script>
import { mapGetters } from 'vuex';

/*
This component displays all details for one boxe
 */
export default {
  name: 'components.chestCard',
  props: {
    detailBoxe: Object,
  },
  computed: {
    ...mapGetters({
      getterListQuestions: 'application/listQuestion',
      getterListGender: 'application/listGender',
    }),
    explicitQuestion() {
      if (!this.getterListQuestions[this.detailBoxe.secretQuestion - 1]) {
        return 'Aucune';
      }
      return this.getterListQuestions[this.detailBoxe.secretQuestion - 1]
        .question;
    },
    explicitUserStatus() {
      if (this.detailBoxe.userStatus === '2') {
        return 'Désactivé';
      }
      if (this.detailBoxe.userStatus === '3') {
        return 'Administrateur';
      }
      return 'Actif';
    },
    cleanEfoliaIds() {
      return this.detailBoxe.efoliaIds.filter(value => value !== null);
    },
  },
};
</script>
